import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-image',
  templateUrl: './svg-image.component.html',
  styleUrls: ['./svg-image.component.css'],
})
export class SvgImageComponent implements OnInit {
  @Input('baseUrl') baseUrl: any = '../../../assets/images/';
  @Input('value') value: any = '';
  @Input('id') id: any = this.value;
  @Input('height') height: number = 16;
  @Input('width') width: number = 16;
  @Input('rotate') rotate: number = 0;
  @Input('stroke') stroke: string = '#333333';
  @Input('fill') fill: string = 'none';
  @Input('className') className: string = 'svg-stroke';
  @Input('svgClassName') svgClassName: string = '';
  constructor() {}

  ngOnInit(): void {}
}
